module.exports = __webpack_public_path__ + "static/media/icon-pencil-white.52cb473f.svg";